export const toggleGroupClasses = 'flex items-center justify-center gap-1';
